module.exports = __webpack_public_path__ + "img/shrooms.5175023b.png";